import { Drawer } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import { FC, useRef } from 'react';
import { DashboardContainerHeader } from '../../pages/MoaDashboard/MoaDashboard.styles';
import Table from '../Table/Table';
import { DrawerProps } from './Drawer.types';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import theme from '../../theme';
import { Header, HeaderText, TableWrapper, SubTextWrapper, ExportButtonWrapper } from './Drawer.styles';
import { H2 } from '../../pages/Dashboard/Dashboard.styles';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import dayjs from 'dayjs';
import { CSVLink } from 'react-csv';
import Button from '../Button/Button';
import { Variant } from '../Button/Button.types';

const SideDrawer: FC<DrawerProps> = ({
  open,
  toggleDrawer,
  title,
  columnDefs,
  rowData,
  drawerType,
  from,
  requestUserName,
}) => {
  const gridRef = useRef<AgGridReact>(null);
  // @ts-ignore
  const muiTheme = createTheme(theme);
  const formattedDate = from ? dayjs(from).format('MMMM D, YYYY') : '';
  const gridOptions = {
    columnDefs: columnDefs,
    tooltipShowDelay: 0,
    tooltipHideDelay: 20000,
  };
  const countResolvedAndFailures = (rowData: any) => {
    const resolvedCount = rowData?.filter((item: { isResolved: boolean }) => item.isResolved === true).length;
    return rowData?.length - resolvedCount;
  };

  const csvFileHeaders = (columnDefs: any) => {
    return columnDefs
      ?.map((colDef: any) => {
        if (colDef.field === 'isResolved') {
          const hasResolvedItems = rowData?.some((item: any) => item.isResolved === true);
          if (!hasResolvedItems) {
            return null;
          }
          return {
            label: 'Is Resolved',
            key: colDef.field || '',
          };
        }
        
        return {
          label: colDef.headerName || '',
          key: colDef.field || '',
        };
      })
      .filter(Boolean);
  };

  const extractDrawerData = () => {
    return rowData?.map((item: any) => {
      const processedItem: any = {};
      columnDefs?.forEach((colDef: any) => {
        const field = colDef.field;
        if (field) {
          if (field === 'isResolved' && item[field] === false) {
            return;
          }
          processedItem[field] = item[field] !== undefined ? String(item[field]) : item[field];
        }
      });
      return processedItem;
    });
  };

  return (
    <ThemeProvider theme={muiTheme} key={'drawer-mui-theme'}>
      <Drawer
        PaperProps={{
          sx: { width: '45%' },
        }}
        anchor={'right'}
        open={open}
        onClose={() => toggleDrawer(false)}
      >
        <Header>
          <DashboardContainerHeader data-testid='header'>{title}</DashboardContainerHeader>
          <HeaderText data-testid={'drawerHeaderDate'}>
            {(drawerType === 'extract' || drawerType === 'activate' || drawerType === 'coupons') && formattedDate}
            <CloseOutlinedIcon onClick={() => toggleDrawer(false)} style={{ paddingLeft: '1rem' }} />
          </HeaderText>
        </Header>
        <TableWrapper data-testid={'drawerContent'}>
          {(drawerType === 'extract' || drawerType === 'activate') && rowData && rowData?.length > 0 && (
            <SubTextWrapper>
              <H2
                data-testid={'drawerDescription'}
                style={{
                  backgroundColor: '#e2e2e0',
                  padding: '1rem',
                  marginLeft: 0,
                  justifyContent: 'space-between',
                  display: 'flex',
                  fontFamily: 'Open Sans',
                  fontSize: 14,
                  borderRadius: 5,
                }}
              >
                Menus: {countResolvedAndFailures(rowData)} failed{' '}
                <H2 style={{ fontFamily: 'Open Sans', fontSize: 14 }}>{requestUserName}</H2>
              </H2>
            </SubTextWrapper>
          )}
          <Table
            rowData={rowData}
            ref={gridRef}
            returnedRecords={rowData?.length}
            columnDefs={columnDefs}
            gridOptions={gridOptions}
            tooltipInteraction={true}
          />
          <ExportButtonWrapper>
            <CSVLink
              data={extractDrawerData() || []}
              headers={csvFileHeaders(columnDefs) || []}
              filename={`${title}_${formattedDate}.csv`}
              target='_blank'
              className='btn btn-primary'
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <Button label='Export to CSV' variant={Variant.Secondary} />
            </CSVLink>
          </ExportButtonWrapper>
        </TableWrapper>
      </Drawer>
    </ThemeProvider>
  );
};

export default SideDrawer;
